import { useJoinInviteSegment } from '@/hooks/useJoinInviteSegment';

// gloss
const InviteSegmentJoiner = () => {
  useJoinInviteSegment();
  return null;
};

export default InviteSegmentJoiner;
